
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkStatus } from '../models/work-status';

export function getUpdateAbsenceDtoFormGroup() {
return new FormGroup({
    status: new FormControl<WorkStatus | undefined>(undefined, [Validators.required]),
    start: new FormControl<string | undefined>(undefined),
    end: new FormControl<string | undefined>(undefined),
    timerecordtypeId: new FormControl<number | undefined>(undefined),
    comment: new FormControl<string | undefined>(''),
    created: new FormControl<string | undefined>(undefined),
    createdBy: new FormControl<number | undefined>(undefined),
    modified: new FormControl<string | undefined>(undefined),
    modifiedBy: new FormControl<number | undefined>(undefined),
})
;
}
      